import { HttpClient, HttpClientOptions } from './httpClient';

const createFeedback =
  (client: HttpClient) =>
  async (
    data: {
      event: Record<string, unknown>;
      name: string;
      email: string;
      comments: string;
    },
    options?: HttpClientOptions
  ) => {
    await client('/feedback/v2', {
      ...options,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
  };

export type VGTVApiClient = ReturnType<typeof createVGTVApi>;

export const createVGTVApi = (client: HttpClient) => {
  return {
    createFeedback: createFeedback(client),
  };
};
